export const introText = `
    Their fleeting indulgence, born of hollow mirth,<br />
    lingered a blight upon the age, and upon that land, long since
    forsaken by grace.<br />
    Their souls, now marred and tarnished, wandered still in search of
    rapture,<br />
    yet reaped naught but the void they themselves had sown.<br /><br />
    O wayward heirs of folly, who grasp at phantoms of grace and
    grandeur,<br />
    ye feast upon echoes of acclaim and yet starveth.<br />
    Hunger was but a whisper of decay,<br />
    yet they, blind and bereft, deemed their curse a blessing.<br /><br />
    <em>Garbed in righteousness not thine own,</em><br />
    <em>ye strut in stolen grace, veiled in false purpose.</em
    ><br /><br />
    And in a land abandoned by flame and light,<br />
    where silence clings to shattered stone,<br />
    a lone soul bent yet unbroken dared forge anew.<br /><br />
    Thus was the Tarnished Land begotten;<br />
    a realm hewn from faded ash and restless will.<br />
    Let those who tread its soil seek meaning and find naught.
`;
